module.exports = __webpack_public_path__ + "media/images/help/team-create-29e41f5fdbed5a2a7fe4001dff6d3359.png";